// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".assets-libraries-info-dialog .info-1{font-size:20px;margin:10px 0 20px 0}.assets-libraries-info-dialog .info-2,.assets-libraries-info-dialog .info-3,.assets-libraries-info-dialog .info-4{margin:20px 0;font-size:20px}.assets-libraries-info-dialog .info-2>div,.assets-libraries-info-dialog .info-3>div,.assets-libraries-info-dialog .info-4>div{margin-left:20px;display:block}\n", ""]);
// Exports
module.exports = exports;
